import { Component, OnInit, EventEmitter } from '@angular/core';
import { Input ,Output} from '@angular/core';
import { TreeNodee } from '../../models/TreeNode.model';

@Component({
  selector: 'app-ha-tree-cpt',
  templateUrl: './ha-tree-cpt.component.html',
  styleUrls: ['./ha-tree-cpt.component.css']
})
export class HaTreeCptComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  @Output() nodeValuecpt = new EventEmitter();
  @Input() treeDatacpt: TreeNodee[];
  nodeName;
  toggleChild(node) {
    node.showChildren = !node.showChildren;
  }

  open(node){
    this.nodeValuecpt.emit(node);
  }

  displayNodeCpt(event){
      this.nodeName=event;
      this.nodeValuecpt.emit(this.nodeName);
    }
}
